import React, { FC, useState } from 'react';
import { ReactComponent as DeletePartnerIcon } from 'assets/icons/delete.svg';
import { BaseModal, Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { toast } from 'react-toastify';
import { RiderType } from 'models/rider.model';
import { apiService } from 'utils/api';
import { getUserName } from 'utils/functions';

interface DeleteRiderModalType {
  show: boolean;
  onClose: (isSuccess?: boolean) => void;
  riders: RiderType[];
}

interface DeleteRiderModalFooterType {
  onCancel: () => void;
  loading: boolean;
  onConfirm: () => void;
}

const DeleteRiderModalFooter: FC<DeleteRiderModalFooterType> = ({
  onCancel,
  onConfirm,
  loading
}) => (
  <div className='grid grid-cols-2 gap-x-4'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

const DeleteRiderModal: FC<DeleteRiderModalType> = ({ show, onClose, riders }) => {
  const [loading, setLoading] = useState<boolean>(false);

  const sendDetails = async () => {
    try {
      setLoading(true);
      await Promise.all(
        riders.map((rider) =>
          apiService.delete(`logistics/rider/${rider.id}`, {
            baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
          })
        )
      );
      toast(<ToastMessage type='success' message='Rider(s) deleted successfully' />);
      onClose(true);
    } catch (error: any) {
      toast(<ToastMessage type='error' message={error.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  return (
    <BaseModal
      isOpen={show}
      title='Delete Rider'
      titleIcon={<DeletePartnerIcon />}
      titleIconColor='danger'
      onRequestClose={() => onClose()}
      footer={
        <DeleteRiderModalFooter
          loading={loading}
          onCancel={() => onClose()}
          onConfirm={sendDetails}
        />
      }>
      <p>
        Are you sure you want to delete
        {riders.length > 1 ? ` these ${riders.length} riders?` : ` ${getUserName(riders[0])}`}
      </p>
    </BaseModal>
  );
};

export default DeleteRiderModal;
